import styled from 'styled-components';
import { media } from 'designsystem/index';
import ds from 'designsystem';
import containerWidth from 'common/consts/containerWidth';

const DesktopNavigationBar = styled.div`        
  height: 100%;
  display: inline-flex;
  align-items: center;
  padding-left: calc(${ds.get('metrics.m')} + ${ds.get('metrics.xxl')});
  
  ${media.largeDesktop`
    position: absolute;
    margin-left: calc((100vw - ${containerWidth}px - 15px) / 2);
    padding-left: 0;`}
  
`;

export default DesktopNavigationBar;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/DesktopNavigationBar.jsx